import workers from "./workers";

export const WORKERS_NAMESPACE = "workers";

export default workers;
